/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Cases_Filter_Selected_CountInputs */

const en_cases_filter_selected_count = /** @type {(inputs: Cases_Filter_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const pt_br2_cases_filter_selected_count = /** @type {(inputs: Cases_Filter_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selecionado(s)`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Cases_Filter_Selected_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_selected_count = /** @type {((inputs: Cases_Filter_Selected_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_Selected_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_selected_count(inputs)
	return pt_br2_cases_filter_selected_count(inputs)
});